import { batchExportExcel, batchExportImage, exportImage, batchExportPDF, batchExportPPTX } from './exportAdapters'

export class ExportHelper {
  type = 'png'
  charts = []
  filters = []
  reportTitle = ''
  constructor(type, charts, filters, reportTitle) {
    this.type = type
    this.charts = charts
    this.filters = filters
    this.reportTitle = reportTitle
  }
  setCharts(charts) {
    this.charts = charts
    return this
  }
  setFilters(filters) {
    this.filters = filters
    return this
  }
  setReportTitle(reportTitle) {
    this.reportTitle = reportTitle
    return this
  }
  setType(type) {
    this.type = type
    return this
  }
  async export() {
    const batchExport = this.charts.length > 1
    switch (this.type) {
      case 'pdf':
        await batchExportPDF(this.charts, this.filters, this.reportTitle)
        break
      case 'pptx':
        await batchExportPPTX(this.charts, this.filters, this.reportTitle)
        break
      case 'png':
        batchExport ? await batchExportImage(this.charts) : await exportImage(this.charts)
        break
      default:
        await batchExportImage(this.charts)
    }
  }
}
